<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('common.btn.exportExcel') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101302"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.region.code')">
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.region.name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.region.nameEnglish')">
            <el-input v-model="editDialog.form.nameEnglish" no="nameEnglish" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.AirlinePerson2')">
            <el-select v-model="editDialog.plannerList" no="chineseName" multiple filterable collapse-tags @change="setSelectValue">
              <el-option v-for="item in allList" :key="item.userId" :value="item.userId" :label="item.chineseName" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRegionList, saveRegion, delRegion } from '@/api/basicData/region'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { User } from '@/class/model/sys/User'

export default {
  name: 'Region',
  components: { cargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.basicData.region.code'),
          field: 'code',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.region.name'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.region.nameEnglish'),
          field: 'nameEnglish',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirlinePerson'),
          field: 'plannerList',
          width: 200,
          cellRenderer: params => this.showName(params.value),
          tooltipValueGetter: (params) => this.showName(params.value)
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          name: '',
          nameEnglish: ''
        },
        plannerList: []
      },
      allList: [],
      seaList: [],
      airList: []
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getRegionList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          code: '',
          name: '',
          nameEnglish: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_Airline')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        // 航线负责人多选 特殊处理
        this.plannerList = []
        const list = this.editDialog.form.plannerList.split(',')
        for (const i of list) {
          let p = 0
          const t = i.split('-')
          if (t.length === 2) {
            p = Number(t[1])
            this.plannerList.push(p)
          }
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_Airline')
      }
      this.classAutoData(this.editDialog.form)
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.region.codeCheck'))
        return
      }
      if (!form.name) {
        self.$message.warning(self.$t('baseInfo.basicData.region.nameCheck'))
        return
      }
      const loading = getLoading()
      saveRegion(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      }).finally(() => loading.close())
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delRegion(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    },
    exportExcel() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          self.$t('baseInfo.basicData.region.code'),
          self.$t('baseInfo.basicData.region.name'),
          self.$t('baseInfo.basicData.region.nameEnglish'),
          self.$t('CargoMsg.Cargo_AirlinePerson')
        ]
        const filterVal = ['code', 'name', 'nameEnglish', 'plannerListStr']
        rows.forEach(row => { row.plannerListStr = this.showName(row.plannerList) })
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Region'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    showName(plannerList) {
      let showName = ''
      if (plannerList && plannerList.length > 0) {
        const list = plannerList.split(',')
        for (const i of list) {
          let p = 0
          const t = i.split('-')
          if (t.length === 2) {
            p = Number(t[1])
          }
          const userName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', p, 'chineseName')
          if (userName) {
            if (showName.length > 0) {
              showName += ','
            }
            showName += userName
          }
        }
      }
      return showName
    },
    setSelectValue(arr) {
      let plannerList = ''
      if (arr) {
        for (const el of arr) {
          plannerList += plannerList ? ',' + this.checkUserRole(el) : this.checkUserRole(el)
        }
      }
      this.editDialog.form.plannerList = plannerList
    },
    checkUserRole(userId) {
      const user = this.allList.find(u => u.userId === userId)
      let t = ''
      if (user) {
        if (this.seaList != null && this.airList != null && this.seaList.includes(user) && this.airList.includes(user)) {
          t = 'ALL-' + user.userId
        } else if (this.seaList.includes(user)) {
          t = 'SE-' + user.userId
        } else if (this.airList.includes(user)) {
          t = 'AE-' + user.userId
        }
      }
      return t
    },
    async classAutoData(entity) {
      this.editDialog.plannerList = []
      if (entity.plannerList) {
        const arrClass = entity.plannerList.split(',')
        for (const cla of arrClass) {
          const t = cla.split('-')
          if (t.length === 2) {
            const p = Number(t[1])
            this.editDialog.plannerList.push(p)
          }
        }
      }
      this.seaList = await User.getUsersByPrivilegeDetail('role', 'sealine', null, this.$store.getters.currentOfficeId)
      this.airList = await User.getUsersByPrivilegeDetail('role', 'airline', null, this.$store.getters.currentOfficeId)
      for (const s of this.seaList) {
        if (this.allList.findIndex(el => el.userId === s.userId) === -1) {
          this.allList.push(s)
        }
      }
      for (const a of this.airList) {
        if (this.allList.findIndex(el => el.userId === a.userId) === -1) {
          this.allList.push(a)
        }
      }
    }
  }
}
</script>

<style>
</style>
